export enum FeaturesRoutingEnum {
  Clients = 'clients',
  BankingFlow = 'banking-flow-repartition',
  Orders = 'orders',
  BankingPartner = 'banking-partner-configurator',
  Cco = 'cco-management',
}
